/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  // 获取在岗学生列表
  Services._workingApplications = data => http.POST('/api/applications/workingApplications', data)
  // 获取历史在岗记录
  Services._workingHistory = data => http.POST('/api/applications/history', data)
  // 添加人员到某岗位
  Services._addToUnit = data => http.POST('/api/applications/add', data)
  // 投递反馈
  Services._myselfAll = data => http.GET('/api/applications/myself', data)
  // 我的岗位
  Services._mywork = data => http.POST('/api/applications/my_history', data)
  // 解聘
  Services._fireApplications = data => http.POST('/api/applications/fire', data)
  // 发送或拒绝面试
  Services._sendOrRefuseInterview = data => http.POST('/api/applications/sendOrRefuse_interview', data)
  // 录入面试结果
  Services._interviewResult = data => http.POST('/api/applications/interviewResult', data)
  // 学工批量审核
  Services._schoolCheck = data => http.POST('/api/applications/schoolCheck', data)
  // 用工单位的批量审批
  Services._submitToSchool = data => http.POST('/api/applications/submitToSchool', data)
  // 单位审核列表
  Services._studentCheckList = data => http.POST('/api/applications/studentCheckList', data)
  return Services
}
export default service
